import { render, staticRenderFns } from "./CheckAllButton.vue?vue&type=template&id=20b16a1b&"
import script from "./CheckAllButton.vue?vue&type=script&lang=js&"
export * from "./CheckAllButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports